import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import type { IntlShape } from "react-intl";

export type PackagingTypeProps = {
	id: string | null | undefined;
	pieces: number;
	intl: IntlShape;
};

export const PackagingType = ({ id, pieces, intl }: PackagingTypeProps) => {
	const localizedKg = intl.formatMessage({ id: "ORC_KG" }) || "KG";
	if (id !== localizedKg.toUpperCase()) {
		console.error(`Unsupported packaging type: "${id}" expected "${localizedKg}". Falling back to pieces.`);
	}
	return <FormattedMessage id="ORC_X_PIECES" values={{ x: pieces }} />;
};

export const IntlPackagingType = injectIntl(PackagingType);
